export const genericColors = {
  // shades of blue
  blueMain: '#0F4C81',
  blueBright: '#177DD6',
  blueSoft: '#6AA0F1',
  blueDim: '#E2EAEE',
  blueAlice: '#F8FCFF',
  blueDark: '#0F2747',
  blueBondi: '#B3DAFF',
  blueRegal: '#004867',
  blueSeagull: '#75B0E7',
  // shades of orange
  orangeMain: '#FC7A1E',
  orangeSoft: '#FB973B',
  orangeLight: '#FFB72D',
  orangePeachy: '#FFBD8E',
  orangeDim: '#FDDEC1',
  orangeBlaze: '#FF5C00',
  orangeZest: '#E47322',
  orangeSandy: '#EF9B60',
  // red and green
  red: '#D40A0A',
  redBright: '#FF0000',
  redMilano: '#B60A0A',
  green: '#117E30',
  // shades of gray
  grayDark: '#4F4F4F',
  grayBoulder: '#7C7C7C',
  gray: '#979797',
  grayLight: '#C8C8C8',
  grayDim: '#EBEBEB',
  grayAlabaster: '#FBFBFB',
  grayDove: '#676767',
  // black and white
  white: '#FFF',
  blackTotal: '#000',
  blackMatt: '#1D1D1F',
  blackMineShaft: '#2C2C2C',
  // shades of sand
  springWood: '#F8F4EF',
  quarterSpanishOrange: '#F7ECDC',
  wildSand: '#F4F4F4',
  bridalWhite: '#FFFBF7',
  sidecarYellow: '#F7EBCC',
  // misc
  blackShadow: 'rgba(0, 0, 0, 0.45)',
  blackShadowLight: 'rgba(200, 200, 200, 0.25)',
};
